import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wtf-data-type-templates',
  templateUrl: './data-type-templates.component.html',
  styleUrls: ['./data-type-templates.component.scss']
})
export class DataTypeTemplatesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
